import React from "react";

export default function Tick(props) {
  return (
    <svg
      className={props.margin ? props.margin : "m20"}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M11.8185 0.826782L11.8185 0.82679L5.27299 8.25076L2.1793 4.81622C1.88139 4.47924 1.38744 4.47959 1.08986 4.81705L1.08985 4.81706C0.804986 5.14012 0.804995 5.6547 1.08984 5.97778L1.08984 5.97778L1.0911 5.97919L4.72947 10.0278C4.72969 10.0281 4.7299 10.0283 4.73012 10.0286C5.02799 10.3657 5.5223 10.3652 5.81969 10.0279L12.9087 1.98754C12.9087 1.98753 12.9087 1.98753 12.9087 1.98753C13.1936 1.66446 13.1935 1.14986 12.9087 0.826797C12.6109 0.488975 12.1163 0.488998 11.8185 0.826782Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
      />
    </svg>
  );
}
